import { memo, FC, HTMLAttributes } from 'react';
import cn from 'classnames';

import Image from '@UI/Image';
import Button from '@UI/Button';
import { WikiArticleData } from '@Types/Wiki';
import styles from './MainArticle.module.css';

export interface MainArticleProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  article: WikiArticleData;
}

const MainArticle: FC<MainArticleProps> = (props) => {
  const { className, article, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.mainArticle, className)}>
      <Image src={article.image} className={styles.poster} loading='eager' />

      <div className={styles.infoBlock}>
        <div className={styles.recommend}>Мы рекомендуем</div>
        <div className={styles.title}>{article.title}</div>
        <div className={styles.text}>{article.text}</div>
        <Button to={article.link} className={styles.buttonRead}>
          Читать статью
        </Button>
      </div>
    </div>
  );
};

export default memo(MainArticle);
